import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import MediaSection from '@/pages/home/components/MediaSection';
import FAQSection from '@/pages/home/components/FAQSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import AboutSection from '@/pages/home/components/AboutSection';
import IndexSection from '@/pages/home/components/IndexSection';
import RankingSection from '@/pages/home/components/RankingSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import AppSection from '@/pages/home/components/AppSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <FAQSection />
        <UpdatesSection />
        <CardsSection />
        <TopicsSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
        <ContactSection />
        <CarouselSection />
        <AppSection />
        <CommentsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}